import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_USER_REQUEST = 'User/FETCH_USER_REQUEST'
const FETCH_USER_SUCCESS = 'User/FETCH_USER_SUCCESS'
const FETCH_USER_FAILURE = 'User/FETCH_USER_FAILURE'

const CREATE_USER_REQUEST = 'User/CREATE_USER_REQUEST'
const CREATE_USER_SUCCESS = 'User/CREATE_USER_SUCCESS'
const CREATE_USER_FAILURE = 'User/CREATE_USER_FAILURE'

const UPDATE_USER_REQUEST = 'User/UPDATE_USER_REQUEST'
const UPDATE_USER_SUCCESS = 'User/UPDATE_USER_SUCCESS'
const UPDATE_USER_FAILURE = 'User/UPDATE_USER_FAILURE'

const DELETE_USER_REQUEST = 'User/DELETE_USER_REQUEST'
const DELETE_USER_SUCCESS = 'User/DELETE_USER_SUCCESS'
const DELETE_USER_FAILURE = 'User/DELETE_USER_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  userList: [],
}

// Default Reducer
const user = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userList: action.payload
      }
    case FETCH_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default user

// Action Creators
export const fetchUserList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_REQUEST
      })

      const response = await API.get(EndPoints.USER+ `/getAll`)
      dispatch({
        type: FETCH_USER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_FAILURE
      })
    }
  }
}

export const createUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_USER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.USER+ `/createUser`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_USER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_USER_FAILURE
      })
    }
  }
}

export const updateUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_USER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.USER+ `/updateUser`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_USER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_USER_FAILURE
      })
    }
  }
}

export const deleteUser = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_USER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.USER + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_USER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_USER_FAILURE
      })
    }
  }
}









// WEBPACK FOOTER //
// ./src/modules/user.js